import { call, METHODS } from '../../services/http-client'

const ROUTE_PREFIX = 'integrations/pricer/pointofsales'

export const getPricerConfiguration = async (posId) => {
    try {
        return await call(METHODS.GET, ROUTE_PREFIX, `${posId}/configuration`)
    } catch (e) {
        console.error(`getPricerConfiguration error: ${e.message}`)
        throw e
    }
}

export const patchPricerConfiguration = async (posId, configuration) => {
    try {
        return await call(METHODS.PATCH, ROUTE_PREFIX, `${posId}/configuration`, configuration)
    } catch (e) {
        console.error(`patchPricerConfiguration error: ${e.message}`)
        throw e
    }
}
